import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import RootRef from 'ha/ui/next/RootRef';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';

import { RenderInputsProps, constants } from 'ha/ui/DateRangeInput';
import SearchBarTextField from './SearchBarTextField';

export const styles = (theme: Theme) =>
  createStyles({
    margin: {
      marginRight: units.rem(0.5),
    },
    grow: {
      flexGrow: 1,
    },
  });

export class DateRangePickerInputs extends React.Component<
  RenderInputsProps & IntlProps & WithStyles<typeof styles>
> {
  startInputRef = React.createRef<HTMLInputElement>();
  endInputRef = React.createRef<HTMLInputElement>();

  componentDidUpdate(prevProps: RenderInputsProps) {
    if (
      prevProps.focusedInput === this.props.focusedInput ||
      !this.startInputRef.current ||
      !this.endInputRef.current
    ) {
      return;
    }
    if (this.props.focusedInput === constants.START_DATE) {
      this.endInputRef.current.blur();
      this.startInputRef.current.focus();
    }
  }

  render() {
    const {
      onFocusChange,
      startDate = '',
      endDate = '',
      setStartDateRef,
      setEndDateRef,
      startDateRequired,
      endDateRequired,
      startDateHasError,
      endDateHasError,
      intl: { T },
      classes,
    } = this.props;

    return (
      <Grid container wrap="nowrap">
        <RootRef rootRef={setStartDateRef}>
          <SearchBarTextField
            inputRef={this.startInputRef}
            className={cx(classes.margin, classes.grow)}
            inputProps={{ readOnly: true }}
            id={constants.START_DATE}
            placeholder={T('Move in')}
            onFocus={() => onFocusChange(constants.START_DATE)}
            value={startDate || ''}
            required={startDateRequired}
            error={startDateHasError}
            data-test-locator="Start Date Home Next"
          />
        </RootRef>
        <RootRef rootRef={setEndDateRef}>
          <SearchBarTextField
            inputRef={this.endInputRef}
            className={classes.grow}
            inputProps={{ readOnly: true }}
            id={constants.END_DATE}
            placeholder={T('Move out')}
            onFocus={() => onFocusChange(constants.END_DATE)}
            value={endDate || ''}
            required={endDateRequired}
            error={endDateHasError}
            data-test-locator="End Date Home Next"
          />
        </RootRef>
      </Grid>
    );
  }
}

export default withStyles(styles)(withIntl(DateRangePickerInputs));
